var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.572,
    height: 50.67,
    viewBox: "0 0 95.572 50.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.82 0.835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91-2.175A7.066,7.066,0,0,1,12,4.856a7.085,7.085,0,0,1-14.17,0A7.066,7.066,0,0,1,4.91-2.175Zm0,9.712A2.712,2.712,0,0,0,7.645,4.856a2.736,2.736,0,0,0-5.47,0A2.712,2.712,0,0,0,4.91,7.537Z",
    transform: "translate(16.086 12.162)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.161,50.67H2.175A2.175,2.175,0,0,1,0,48.495V2.175A2.175,2.175,0,0,1,2.175,0h58.78A2.175,2.175,0,0,1,63.13,2.175v16.8a2.175,2.175,0,1,1-4.35,0V4.35H4.35V46.32H6.161a2.053,2.053,0,0,0,1.652-.828l7.759-10.561a5.471,5.471,0,0,1,8.324-.565l2.717,2.8a1.122,1.122,0,0,0,1.7-.115l7.873-10.8a5.47,5.47,0,0,1,8.7-.162l11.6,14.724A2.175,2.175,0,1,1,53.071,43.5L41.47,28.778a1.12,1.12,0,0,0-1.771.032l-7.873,10.8a5.472,5.472,0,0,1-8.336.583l-2.717-2.8a1.121,1.121,0,0,0-1.7.112l-7.76,10.561A6.419,6.419,0,0,1,6.161,50.67Z",
    transform: "translate(-0.82 -0.835)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.411,43.327c-3.518-.269-6.537,3.025-7.375,7.539a14.973,14.973,0,0,1-3.845,7.413s9.581.888,13.983-3.464a9,9,0,0,0,2.933-5.828c.134-2.943-1.874-5.367-5.7-5.66",
    transform: "translate(-32.876 -16.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.009,41.318h0c.184,0,.37.007.553.021a8.476,8.476,0,0,1,5.622,2.448,7.107,7.107,0,0,1,1.913,5.29,11,11,0,0,1-3.523,7.156,14.1,14.1,0,0,1-6.95,3.456,29.829,29.829,0,0,1-6.379.659c-1.327,0-2.2-.08-2.24-.083a1.988,1.988,0,0,1-1.2-3.421A13.118,13.118,0,0,0,89.076,50.5C90.08,45.095,93.753,41.318,98.009,41.318ZM91.119,56.3c2.665-.175,6.534-.806,8.653-2.9a7.086,7.086,0,0,0,2.343-4.5c.093-2.051-1.348-3.389-3.856-3.581-.083-.006-.167-.01-.249-.01-2.267,0-4.376,2.491-5.013,5.925A16.357,16.357,0,0,1,91.119,56.3Z",
    transform: "translate(-32.876 -16.627)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.465,27.679,127.893,2.558l4.254,3.5-21.533,27.22a6.889,6.889,0,0,0-6.15-5.6",
    transform: "translate(-39.389 -0.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.615,35.271a1.994,1.994,0,0,1-1.956-1.607,4.952,4.952,0,0,0-4.473-4.011,1.994,1.994,0,0,1-1.179-3.334L126.435,1.2a1.994,1.994,0,0,1,2.725-.18l4.254,3.5a1.994,1.994,0,0,1,.3,2.777l-21.533,27.22A1.994,1.994,0,0,1,110.615,35.271Zm-2.556-8.522a8.549,8.549,0,0,1,3.06,2.676L129.37,6.354l-1.3-1.066Z",
    transform: "translate(-39.389 -0.982)",
    fill: "#0d2a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.216,61.721a21.528,21.528,0,0,1-7.963,1.456A16.4,16.4,0,0,0,93.286,59.1c1.147,1.983,5.3,2.193,5.93,2.626",
    transform: "translate(-34.408 -22.686)",
    fill: "#759ce2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H94V49H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e7859f3dc916cf9ab873caa5ac7048f7.svg";
export { ForwardRef as ReactComponent };